import { InterviewScore } from '.';

export type TechnicalChallengeCompetency = {
  id?: string;
  name?: string;
  weight?: number;
  scores?: InterviewScore[];
  createdAt?: Date;
  updatedAt?: Date;
};

export enum CompetencyScoreInputTypeEnum {
  BOOLEAN = 'BOOLEAN',
  NUMERIC_RANGE = 'NUMERIC_RANGE',
}

export type TechnicalChallengeCompetencyScore = {
  id?: string;
  competency?: TechnicalChallengeCompetency;
  scoreEnum?: string;
  createdAt?: Date;
  updatedAt?: Date;
  question: string;
  inputType: CompetencyScoreInputTypeEnum;
  maxScoreValue?: number;
};
